var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 17.3333C4.39758 17.3333 0.666626 13.6023 0.666626 8.99999C0.666626 4.39761 4.39758 0.666656 8.99996 0.666656C13.6023 0.666656 17.3333 4.39761 17.3333 8.99999C17.3333 13.6023 13.6023 17.3333 8.99996 17.3333ZM8.99996 15.6667C12.6819 15.6667 15.6666 12.6819 15.6666 8.99999C15.6666 5.31809 12.6819 2.33332 8.99996 2.33332C5.31806 2.33332 2.33329 5.31809 2.33329 8.99999C2.33329 12.6819 5.31806 15.6667 8.99996 15.6667ZM8.16663 11.5H9.83329V13.1667H8.16663V11.5ZM9.83329 10.1292V10.6667H8.16663V9.41666C8.16663 8.95641 8.53971 8.58332 8.99996 8.58332C9.69029 8.58332 10.25 8.02366 10.25 7.33332C10.25 6.64296 9.69029 6.08332 8.99996 6.08332C8.39354 6.08332 7.88796 6.51518 7.77396 7.08813L6.13938 6.76121C6.40527 5.42431 7.58496 4.41666 8.99996 4.41666C10.6108 4.41666 11.9166 5.72249 11.9166 7.33332C11.9166 8.65457 11.038 9.77066 9.83329 10.1292Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f09f3c9e8423046d053c66d81988b53b.svg";
export { ForwardRef as ReactComponent };